import { PageStoreProvider } from "./application-detail-page.lib";
import { ApplicationDictionariesProvider } from "./application-dictionaries-context";
import { ApplicationControlEmployeeModal } from "./local-components/application-control-employee-modal";
import { ApplicationControlModals } from "./local-components/application-control-modals";
import { ApplicationControlRejectModal } from "./local-components/application-control-reject-modal";
import { ApplicationControlRegionDepartmentsModal } from "./local-components/application-control-region-departments-modal";
import { ApplicationDetailImportModal } from "./local-components/application-detail-import-modal";
import { ApplicationDetailHeader } from "./local-components/application-detail-header";
import { ApplicationDetailPageContent } from "./local-components/application-detail-page-content";
import { ApplicationDetailTabContent } from "./local-components/application-detail-tab-content";
import { ApplicationDetailTabGroup } from "./local-components/application-detail-tab-group";
import { ApplicationStatusBanner } from "./local-components/application-status-banner";
import { GoBackButton } from "./local-components/go-back-button";
import { PaymentInvoiceModal } from "./local-components/payment-tab/payment-invoice-modal";
import { PaymentProofPopup } from "./local-components/payment-tab/payment-proof-popup";
import { ReviewDocumentUploadModalWrapper } from "./local-components/review-documents-tab/review-document-upload-modal";
import { TuPartUploadModalWrapper } from "./local-components/review-documents-tab/tu-part-upload-modal";

const ApplicationDetailPage = () => (
  <ApplicationDictionariesProvider>
    <PageStoreProvider>
      <ApplicationDetailImportModal />
      <ApplicationControlModals />
      <ApplicationControlEmployeeModal />
      <ApplicationControlRejectModal />
      <ApplicationControlRegionDepartmentsModal />
      <PaymentInvoiceModal />
      <PaymentProofPopup />
      <ReviewDocumentUploadModalWrapper />
      <TuPartUploadModalWrapper />
      <ApplicationDetailPageContent>
        <main className="bg-neutrals-99 flex min-h-0 w-full flex-1 flex-col overflow-y-auto px-8 py-6">
          <div className="mx-auto flex w-full max-w-[76rem] flex-col gap-6">
            <ApplicationStatusBanner />
            <GoBackButton className="w-fit" />
            <ApplicationDetailHeader />
            <section className="bg-neutrals-white flex min-w-0 flex-col gap-4 rounded-xl p-6">
              <ApplicationDetailTabGroup />
              <ApplicationDetailTabContent />
            </section>
          </div>
        </main>
      </ApplicationDetailPageContent>
    </PageStoreProvider>
  </ApplicationDictionariesProvider>
);

export default ApplicationDetailPage;
